(function() {
  var searchInput = document.querySelector('.js-rules-search');
  var brandSelect = document.querySelector('.js-rules-brand');
  var grid = document.querySelector('.js-rules-grid');
  var noResults = document.querySelector('.js-rules-no-results');
  if (!grid || (!searchInput && !brandSelect)) return;

  function normalize(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  var cards = Array.from(grid.querySelectorAll('li[data-short-name]')).map(function(li) {
    return {
      el: li,
      name: normalize(li.dataset.shortName),
      vendor: li.dataset.vendor
    };
  });

  function filterCards() {
    var query = searchInput ? normalize(searchInput.value.trim()) : '';
    var brand = brandSelect ? brandSelect.value : '';
    var visibleCount = 0;

    cards.forEach(function(card) {
      var matchesSearch = !query || card.name.includes(query);
      var matchesBrand = !brand || card.vendor === brand;
      var visible = matchesSearch && matchesBrand;
      card.el.classList.toggle('hidden', !visible);
      if (visible) visibleCount++;
    });

    if (noResults) {
      noResults.classList.toggle('hidden', visibleCount > 0);
    }
  }

  if (searchInput) searchInput.addEventListener('input', filterCards);
  if (brandSelect) brandSelect.addEventListener('change', filterCards);
})();
